/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerDemographicsAddComponent
 * Purpose		: This component allows to create new CustomerDemographics record and save changes.
 * Dependency	: CustomerDemographicsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit,
	HostBinding, trigger, transition, animate,
	style, state } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { CustomerDemographicsData, CustomerDemographicsService } from './CustomerDemographics.service';


@Component({
	selector: 'my-CustomerDemographics-add',
	template: require('./CustomerDemographicsAdd.component.html'),
	providers: [CustomerDemographicsService
		
		],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class CustomerDemographicsAddComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }

	objCustomerDemographics: CustomerDemographicsData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	

  constructor(
    private route: ActivatedRoute,
    private router: Router,
	private toastr: ToastsManager,
    private CustomerDemographicsService: CustomerDemographicsService

	) {
		this.objCustomerDemographics = new CustomerDemographicsData();
	}

	ngOnInit() {
		this.objCustomerDemographics = new CustomerDemographicsData();
		this.getLookups();
	}

	addCustomerDemographics() {
		this.CustomerDemographicsService.addCustomerDemographicsData(this.objCustomerDemographics)
			.subscribe(record => this.router.navigate(['/CustomerDemographics']),
			error =>  this.errorMessage = 'There was an error while adding record. Error: ' + <any>error,
			() => { 
				this.toastr.success('CustomerDemographics record added successfully...', 'Add CustomerDemographics');
				console.log('CustomerDemographics record added successfully...'); 
			}
		);
	}

	gotoCustomerDemographics() {
		// let Id = this.objCustomerDemographics ? this.objCustomerDemographics.CustomerTypeID : null;
		this.router.navigate(['/CustomerDemographics']);
	}


	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CustomerDemographics/CustomerDemographicsAdd.component.ts